export default "/_next/static/node_modules/@riot-private/blades-ui/dist/skins/rg-product-pages/assets/arrow-right.svg";